import styled from "styled-components";

let S = {};

S.Container = styled.div`
	margin-bottom: 5px;

	& button {
		width: 100% !important;
		display: inline-block;
		border: none;
		border: 1px solid var(--primary);
		border-radius: 2px;
		padding: 7.5px 5px 6px 5px;
		margin: 0;
		text-decoration: none;
		background-color: var(--primary);
		color: #fff;
		font-family: inherit;
		font-size: 1rem;
		font-weight: bold;
		cursor: pointer;
		appearance: none;
		-moz-appearance: none;
		outline: none;
		transition: all 0.3s;

		&:hover {
			color: var(--secondary);
		}

		& > div {
			display: flex;
			align-items: center;
			justify-content: center;

			& > span {
				padding-right: 7.5px;
				text-transform: uppercase;
				letter-spacing: 0.5px;
			}
		}
	}
`;

export default S;
